export default __webpack_public_path__ + "static/media/hummel_rund.1be81db5.jpg";